<template>
  <div>
    <div class="dashboard-kpi p-2">
      <div class="pointer" style="position:absolute;right:3%; top: 2%;" @click="downloadReport()">
        <i class="fa-solid fa-file-arrow-down" style="color:red;  font-size: large;"></i>
      </div>
      <div class="text-bold text-center">Supplier Satisfaction Index - Top 10 Vendor PO Amount</div>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>No</th>
              <th style="width: 200px;">Nama Vendor</th>
              <th class="text-center">Nilai</th>
              <th>Tingkat Kepuasan</th>
              <th>Nilai PO</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in ssiChart" :key="index">
              <td>{{ index + 1 }}</td>
              <td style="width: 200px;">{{ item.vendor_name }}</td>
              <td class="text-center">{{ parseInt(item.csi_score) }}</td>
              <td>{{ item.csi_desc }}</td>
              <td>{{ curencyDelimiter(item.total_value) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
export default {
  components: {
  },
  data() {
    return {
      data: [
        {
          namaVendor: 'AKR CORPORINDO TBK, PT',
          nilai: 5,
          tingkatKepuasan: 'Sangat Memuaskan',
          nilaiPO: '58.478.328.841',
        },
        {
          namaVendor: 'TRIPUTRA ENERGI MEGATARA, PT',
          nilai: 3,
          tingkatKepuasan: 'Cukup Memuaskan',
          nilaiPO: '46.200.111.464',
        },
        {
          namaVendor: 'PERTAMINA PATRA NIAGA, PT',
          nilai: 4,
          tingkatKepuasan: 'Memuaskan',
          nilaiPO: '43.630.081.833',
        },
        {
          namaVendor: 'KHI PIPE INDUSTRIES, PT',
          nilai: 5,
          tingkatKepuasan: 'Sangat Memuaskan',
          nilaiPO: '43.435.615.058',
        },
        {
          namaVendor: 'JAKARTA PRIMA CRANES, PT',
          nilai: 3,
          tingkatKepuasan: 'Cukup Memuaskan',
          nilaiPO: '43.317.923.688',
        },
        {
          namaVendor: 'USTON PRATAMA, PT',
          nilai: 3,
          tingkatKepuasan: 'Cukup Memuaskan',
          nilaiPO: '43.271.621.186',
        },
        {
          namaVendor: 'TRANSKON JAYA, PT TBK',
          nilai: 4,
          tingkatKepuasan: 'Memuaskan',
          nilaiPO: '43.345.263.721',
        },
        {
          namaVendor: 'TETRASA GEOSININDO, PT',
          nilai: 5,
          tingkatKepuasan: 'Sangat Memuaskan',
          nilaiPO: '40.454.373.719',
        },
        {
          namaVendor: 'ASPAL POLIMER EMULSINDO, PT',
          nilai: 4,
          tingkatKepuasan: 'Memuaskan',
          nilaiPO: '39.405.762.684',
        },
        {
          namaVendor: 'DATAMINE SOFTWARE INDONESIA, PT',
          nilai: 4,
          tingkatKepuasan: 'Memuaskan',
          nilaiPO: '1.045.440.000',
        },

      ],
    }
  },
  computed: {
    ssiChart() {
      const top = this.$store.state.kpiStore.ssiChartTop10Vendor

      return top

    },
  },
  methods: {
    downloadReport() {
      const exportTitle = 'SSI - Top 10 Vendor PO Amount'
      let newData = this.ssiChart.map((item, index) => {
        let newDataItem = {
          no: index + 1,
          namaVendor: item.vendor_name,
          nilai: item.csi_score,
          tingkatKepuasan: item.csi_desc,
          nilaiPO: this.curencyDelimiter(item.total_value),
        }

        return newDataItem
      })

      // newData.unshift({})

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(newData)
        const title = [
          ['No', 'Nama Vendor', 'Nilai', 'Tingkat Kepuasan', 'Nilai PO']
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
  }
}
</script>

<style scoped>
.table-wrapper {
  margin-top: 2rem;
  padding: 1rem;
  max-height: 500px;
  overflow-y: scroll;
}

table {
  /* margin: 2rem auto 0 auto; */
  margin: 0 auto;
  width: 100%;
  color: var(--gray-900, #101828);
  /* text-align: center; */
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

td {
  padding-left: 0px;
  padding-right: 0px;
}

table,
tr,
td {
  border: none;
  /* padding-left: 1rem;
  padding-right: 1rem; */
}
</style>